export default "__VITE_ASSET__DUJgsUrs__"